<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="1100" persistent>
    <div class="modern-modal">
      <div class="modern-modal-header d-flex justify-content-between align-items-center" style="padding: 24px 32px; background: #fff; border-bottom: 1px solid #e2e8f0; border-radius: 16px 16px 0 0;">
        <div class="d-flex align-items-center gap-3">
          <div class="modern-modal-icon" style="background: linear-gradient(135deg, #6366f1, #4f46e5); color: #fff; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; border-radius: 10px;">
            <i class="fa-solid fa-layer-group"></i>
          </div>
          <div>
            <h3 style="margin: 0; font-size: 18px; font-weight: 700; color: #1e293b;">Shablonlarni boshqarish</h3>
            <p style="margin: 0; font-size: 12px; color: #64748b;">Tizimdagi tayyor vazifa shablonlarini sozlash</p>
          </div>
        </div>
        <button type="button" class="btn btn-light rounded-circle" @click="closeModal" style="width: 36px; height: 36px; padding: 0;">
          <i class="fa fa-times text-muted"></i>
        </button>
      </div>

      <div class="modern-modal-body" style="background: #f8fafc; padding: 0; border-radius: 0 0 16px 16px; overflow: hidden;">
        <div class="row g-0">
          <!-- CHAP PANEL: Shablonlar Ro'yxati -->
          <div class="col-md-4" style="background: #ffffff; border-right: 1px solid #e2e8f0; height: calc(100vh - 200px); max-height: 600px; overflow-y: auto;">
            <div class="p-3 border-bottom sticky-top" style="background: #ffffff; z-index: 10;">
              <button class="btn btn-primary w-100 fw-semibold" @click="createNew" style="border-radius: 8px;">
                <i class="fa-solid fa-plus me-1"></i> Yangi shablon
              </button>
            </div>
            
            <div class="p-2">
              <div v-if="loading" class="text-center p-4">
                <div class="spinner-border text-primary spinner-border-sm" role="status"></div>
              </div>
              <div v-else-if="templates.length === 0" class="text-center p-4 text-muted" style="font-size: 13px;">
                Shablonlar mavjud emas
              </div>
              <div v-else class="list-group list-group-flush">
                <button 
                  v-for="t in templates" 
                  :key="t.id"
                  @click="selectTemplate(t)"
                  class="list-group-item list-group-item-action d-flex align-items-center py-3 border-0 rounded mb-1"
                  :class="{ 'active-template': selectedId === t.id }"
                  style="cursor: pointer; transition: 0.2s;"
                >
                  <div class="avatar-xs me-3 flex-shrink-0">
                    <span class="avatar-title rounded-circle" :class="selectedId === t.id ? 'bg-primary text-white' : 'bg-light text-primary'" style="font-size: 14px; width: 36px; height: 36px;">
                      <i :class="t.icon || 'fa-solid fa-file-lines'"></i>
                    </span>
                  </div>
                  <div class="flex-grow-1 overflow-hidden" style="text-align: left;">
                    <h6 class="mb-1 text-truncate" :class="selectedId === t.id ? 'text-white' : 'text-dark'" style="font-size: 14px; font-weight: 600;">{{ t.name }}</h6>
                    <p class="mb-0 text-truncate" :class="selectedId === t.id ? 'text-white-50' : 'text-muted'" style="font-size: 12px;">{{ t.description }}</p>
                  </div>
                </button>
              </div>
            </div>
          </div>

          <!-- O'NG PANEL: Tahrirlash Formasi -->
          <div class="col-md-8" style="height: calc(100vh - 200px); max-height: 600px; overflow-y: auto;">
            <div v-if="!form.id && !isCreating" class="h-100 d-flex flex-column align-items-center justify-content-center text-muted" style="background: #f8fafc;">
              <i class="fa-regular fa-hand-pointer mb-3" style="font-size: 40px; color: #cbd5e1;"></i>
              <p style="font-size: 14px;">Tahrirlash uchun chapdan shablon tanlang</p>
            </div>
            
            <form v-else @submit.prevent="saveTemplate" class="p-4" autocomplete="off">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <h5 class="mb-0 text-dark fw-bold" style="font-size: 16px;">
                  {{ isCreating ? "Yangi shablon yaratish" : "Shablonni tahrirlash" }}
                </h5>
                <button v-if="form.id" type="button" class="btn btn-soft-danger btn-sm" @click="deleteTemplate(form.id)">
                  <i class="fa-solid fa-trash me-1"></i> O'chirish
                </button>
              </div>

              <!-- Shablon Asosiy Ma'lumotlari -->
              <div class="card shadow-none border mb-4" style="border-radius: 12px;">
                <div class="card-header bg-transparent border-bottom-0 pb-0 pt-3">
                  <h6 class="text-uppercase text-muted fw-bold mb-0" style="font-size: 11px; letter-spacing: 0.5px;">1. Shablon ma'lumotlari</h6>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-md-8">
                      <label class="form-label" style="font-size: 12px; font-weight: 600; color: #475569;">Shablon nomi <span class="text-danger">*</span></label>
                      <input type="text" class="form-control bg-light border-0" v-model="form.name" required placeholder="Masalan: Oylik hisobot" />
                    </div>
                    <div class="col-md-4">
                      <label class="form-label" style="font-size: 12px; font-weight: 600; color: #475569;">Ikonka klassi</label>
                      <input type="text" class="form-control bg-light border-0" v-model="form.icon" placeholder="fa-solid fa-star" />
                    </div>
                    <div class="col-12">
                      <label class="form-label" style="font-size: 12px; font-weight: 600; color: #475569;">Shablon tavsifi</label>
                      <textarea class="form-control bg-light border-0" rows="2" v-model="form.description" placeholder="Shablon haqida qisqacha..."></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Topshiriq Standarti -->
              <div class="card shadow-none border mb-4" style="border-radius: 12px;">
                <div class="card-header bg-transparent border-bottom-0 pb-0 pt-3">
                  <h6 class="text-uppercase text-muted fw-bold mb-0" style="font-size: 11px; letter-spacing: 0.5px;">2. Asosiy Vazifa Standarti</h6>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <label class="form-label" style="font-size: 12px; font-weight: 600; color: #475569;">Vazifa sarlavhasi <span class="text-danger">*</span></label>
                    <input type="text" class="form-control bg-light border-0" v-model="form.task_name" required placeholder="Vazifa nomini kiriting" />
                  </div>
                  <div>
                    <label class="form-label" style="font-size: 12px; font-weight: 600; color: #475569;">Vazifa to'liq tavsifi</label>
                    <textarea class="form-control bg-light border-0" rows="3" v-model="form.task_description" placeholder="Vazifa ichiga avtomatik yoziladigan matn..."></textarea>
                  </div>
                </div>
              </div>

              <!-- Subtasks -->
              <div class="card shadow-none border mb-4" style="border-radius: 12px;">
                <div class="card-header bg-transparent d-flex justify-content-between align-items-center pt-3 pb-2 border-bottom">
                  <h6 class="text-uppercase text-muted fw-bold mb-0" style="font-size: 11px; letter-spacing: 0.5px;">3. Kichik Topshiriqlar (Subtasks)</h6>
                  <button type="button" class="btn btn-soft-primary btn-sm" @click="addSubtask" style="border-radius: 6px; font-weight: 600;">
                    <i class="fa-solid fa-plus me-1"></i> Qo'shish
                  </button>
                </div>
                <div class="card-body bg-light" style="border-radius: 0 0 12px 12px;">
                  <div v-for="(sub, idx) in form.subtasks" :key="idx" class="p-3 mb-3 bg-white border" style="border-radius: 8px; position: relative;">
                    <button type="button" class="btn btn-link text-danger p-0 position-absolute" @click="removeSubtask(idx)" style="top: 10px; right: 12px;">
                      <i class="fa fa-times"></i>
                    </button>
                    <h6 style="font-size: 11px; font-weight: 700; color: #94a3b8; margin-bottom: 8px;">SUBTASK #{{ idx + 1 }}</h6>
                    <div class="mb-2">
                      <input type="text" class="form-control form-control-sm" v-model="sub.name" placeholder="Subtask nomi" required />
                    </div>
                    <div>
                      <textarea class="form-control form-control-sm" rows="2" v-model="sub.description" placeholder="Tavsif (ixtiyoriy)"></textarea>
                    </div>
                  </div>
                  
                  <div v-if="form.subtasks.length === 0" class="text-center p-3 text-muted" style="font-size: 12px; border: 1px dashed #cbd5e1; border-radius: 8px;">
                    Ichki topshiriqlar qo'shilmagan
                  </div>
                </div>
              </div>

              <!-- Submit -->
              <div class="text-end">
                <button type="button" class="btn btn-light me-2" @click="closeModal" style="border-radius: 8px; font-weight: 600;">Bekor qilish</button>
                <button type="submit" class="btn btn-primary" :disabled="isSaving" style="border-radius: 8px; font-weight: 600;">
                  <i class="fa-solid fa-save me-1" v-if="!isSaving"></i> 
                  <span v-if="isSaving" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  {{ isCreating ? "Yaratish" : "Saqlash" }}
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import api from "@/services/api";
import Swal from "sweetalert2";

export default {
  name: "TemplateManagerModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      templates: [],
      loading: false,
      isSaving: false,
      isCreating: false,
      selectedId: null,
      form: {
        id: null,
        name: "",
        description: "",
        icon: "",
        task_name: "",
        task_description: "",
        subtasks: []
      }
    };
  },
  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.loadTemplates();
        this.resetForm();
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("update:modelValue", false);
    },
    resetForm() {
      this.isCreating = false;
      this.selectedId = null;
      this.form = {
        id: null,
        name: "",
        description: "",
        icon: "fa-solid fa-file-lines",
        task_name: "",
        task_description: "",
        subtasks: []
      };
    },
    createNew() {
      this.resetForm();
      this.isCreating = true;
    },
    selectTemplate(t) {
      this.isCreating = false;
      this.selectedId = t.id;
      // Copy properties to form to avoid direct mutation before save
      this.form = {
        id: t.id,
        name: t.name,
        description: t.description || "",
        icon: t.icon || "fa-solid fa-file-lines",
        task_name: t.task_name || t.name,
        task_description: t.task_description || t.description || "",
        subtasks: Array.isArray(t.subtasks) 
          ? JSON.parse(JSON.stringify(t.subtasks)) 
          : Array.isArray(t.task_templates_subtasks)
            ? JSON.parse(JSON.stringify(t.task_templates_subtasks))
            : []
      };
    },
    addSubtask() {
      this.form.subtasks.push({ name: "", description: "" });
    },
    removeSubtask(idx) {
      this.form.subtasks.splice(idx, 1);
    },
    async loadTemplates() {
      this.loading = true;
      try {
        const response = await api.get('/task-templates');
        this.templates = response.data?.data || response.data || [];
      } catch (error) {
        console.error("Shablonlarni yuklash xatosi:", error);
      } finally {
        this.loading = false;
      }
    },
    async saveTemplate() {
      this.isSaving = true;
      try {
        const payload = {
          name: this.form.name,
          description: this.form.description,
          icon: this.form.icon,
          task_name: this.form.task_name,
          task_description: this.form.task_description,
          subtasks: this.form.subtasks
        };

        if (this.isCreating) {
          await api.post('/task-templates', payload);
          Swal.fire({ icon: 'success', title: 'Yaratildi', timer: 1500, showConfirmButton: false });
        } else {
          await api.put(`/task-templates/${this.form.id}`, payload);
          Swal.fire({ icon: 'success', title: 'Saqlandi', timer: 1500, showConfirmButton: false });
        }
        
        await this.loadTemplates();
        this.$emit("updated");
        this.resetForm();
      } catch (error) {
        console.error("Saqlash xatosi:", error);
        Swal.fire({ icon: 'error', title: 'Xatolik', text: 'Shablonni saqlashda muammo yuz berdi' });
      } finally {
        this.isSaving = false;
      }
    },
    async deleteTemplate(id) {
      const result = await Swal.fire({
        title: "Tasdiqlaysizmi?",
        text: "Bu shablon butunlay o'chib ketadi!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#64748b",
        confirmButtonText: "Ha, o'chirilsin",
        cancelButtonText: "Bekor qilish",
        customClass: { container: 'swal-z-top' }
      });

      if (result.isConfirmed) {
        try {
          await api.delete(`/task-templates/${id}`);
          Swal.fire({ icon: 'success', title: "O'chirildi!", timer: 1500, showConfirmButton: false });
          await this.loadTemplates();
          this.$emit("updated");
          this.resetForm();
        } catch (error) {
          console.error("O'chirish xatosi:", error);
          Swal.fire({ icon: 'error', title: 'Xatolik', text: 'O\'chirishda muammo yuz berdi' });
        }
      }
    }
  }
};
</script>

<style scoped>
.active-template {
  background-color: #4f46e5 !important;
  color: #fff !important;
}
.active-template .avatar-title {
  background-color: #fff !important;
  color: #4f46e5 !important;
}
.active-template h6, .active-template p {
  color: #fff !important;
}
.swal-z-top {
  z-index: 99999 !important;
}
</style>
